import type { FC } from "react";

import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { AntCustomFormField } from "../../types/types";
import { IdGenerator } from "../IdGenerator/IdGenerator";

export interface InputGeneratorProps extends AntCustomFormField<string> {
    label: string;
    readOnly: boolean;
    inputIsDisabled: boolean;
    name: string;
    acquirerId?: string;
    terminalId?: string;
}

export const TerminalHostIdGenerator: FC<InputGeneratorProps> = ({ acquirerId, terminalId, inputIsDisabled, ...restProps }) => {
    const fetchUrl = `/${ResourceName.TERMINAL_HOST_ID_GENERATOR}?terminalId=${terminalId}&acquirerId=${acquirerId}`;

    return <IdGenerator fetchUrl={fetchUrl} buttonName="terminalHostIdGenerator_button" inputIsDisabled={inputIsDisabled} {...restProps} />;
};
